export enum ActionButtonList {
  VIEW = 'view',
  EDIT = 'edit',
  FAVOURITE = 'favourite',
  REFRESH = 'refresh',
  DELETE = 'delete',
}
